import React from 'react';
import { documentConfig } from '../../constants/documentConfig';
import { dotColor } from './scoreColor';

const DocumentChip = ({ result, isActive, onClick }) => {
  const label = documentConfig[result.docType]?.label || result.docType;
  const score = result.atsOverall;

  return (
    <button
      className={`doc-chip ${isActive ? 'doc-chip--active' : ''}`}
      onClick={onClick}
    >
      <span className="doc-chip-dot" style={{ background: result.failed ? 'var(--score-red)' : dotColor(score) }} />
      {label}
    </button>
  );
};

export default DocumentChip;
